import { axios } from '../plugins/http-axios';
import { defineStore } from 'pinia';

export interface I18n {
  [key: string]: string;
}

interface I18nState {
  i18n: I18n;
  i18nBank: I18n;
  i18nLkk: I18n;
}

export const useI18nStore = defineStore('i18n', {
  state: (): I18nState => ({
    i18n: {},
    i18nBank: {},
    i18nLkk: {},
  }),

  getters: {
    isI18nLkk: (state) => !!Object.keys(state.i18nLkk).length,
    voc: (state) => ({
      ...state.i18n,
      ...state.i18nBank,
      ...state.i18nLkk,
    }),
  },

  actions: {
    async getI18n() {
      const mainStore = useMainStore();

      try {
        const resp = await axios.get(mainStore.getUri.infoSystemInfoLogin);
        const data = {
          ...resp.data.i18n,
          version: resp.data.version,
        };
        this.i18n = data;
      } catch (e: any) {
        return Promise.reject(e);
      }
    },

    async getI18nLkk(): Promise<I18n> {
      if (this.isI18nLkk) {
        return this.i18nLkk;
      }

      const mainStore = useMainStore();

      try {
        const resp = await axios.get<I18n>(mainStore.getUri.i18nLkk);
        this.i18nLkk = resp.data;
        return resp.data;
      } catch (e: any) {
        return Promise.reject(e);
      }
    },

    setI18n(data: I18n = {}) {
      this.i18n = data;
    },

    setI18nBank(data: I18n = {}) {
      this.i18nBank = data;
    },

    setI18nLkk(data: I18n = {}) {
      this.i18nLkk = data;
    },
  },
});

import { useMainStore } from './mainStore';
export default useI18nStore;
